import { Code as ChakraCode, CodeProps as ChakraCodeProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { getFontFromVariant } from '../../_helpers';
import { InferPropTypes } from '../../types';

/*
 * Renders a component specifically for code snippets (code)
 *
 * @prop {ReactNode} children -> The child node that renders inside of the component
 * @prop {String (Enumerable)} fontSize -> Describes the font-size style of the component
 *                                         If no override provides, it inherits from parent component
 * @prop {String (Enumerable)} fontWeight -> Describes the font-weight style of the component
 */

const propTypes = {
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.oneOf(['sm', 'md', 'lg']),
  fontWeight: PropTypes.oneOf(['normal', 'semibold'])
};

const defaultProps = {
  fontSize: 'md',
  fontWeight: 'normal'
};

export type CodeProps = ChakraCodeProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

export default function Code(props: CodeProps): React.ReactElement {
  const { children, fontWeight, ...rest } = props;

  const fontFamily = getFontFromVariant('code', fontWeight);

  return (
    <ChakraCode bg="transparent" fontFamily={fontFamily} fontWeight={fontWeight} {...rest}>
      {children}
    </ChakraCode>
  );
}

Code.propTypes = propTypes;
Code.defaultProps = defaultProps;
